<template>
	<div class="con">
		<div class="wx-header">
			<div class="wx-header-content" @touchstart="showInfo">
				<div v-if="!toShowMaskInfo" class="xw-header-title">展开信息</div>
			</div>
			<!-- 头部弹出 -->
			<div v-show="toShowMaskInfo" :class="[toShowMaskInfo ? 'bounceInDown' : '' , 'xw-show-info-box', 'animated']">
				<div class="xw-logo">
					<img v-if="headInfo.headImg == ' ' || headInfo.headImg == undefined" src="../assets/doctor.png" class="wx-header-avatar">
					<img v-else :src="headInfo.headImg" class="wx-header-avatar">
					<h3>{{headInfo.name}}</h3>
				</div>
				<div class="xw-header-info">
					<p class="animated bounceInLeft">
						{{headInfo.text}}
					</p>
				</div>
			</div>
		</div>

		<div class="wx-content" @touchstart="toShowMaskInfo = false" ref="xwBody">
			<div class="xw-chat-wrap">
				<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
					<ul>
						<li v-for="messageList in records">
							<!--医生发的消息-->
							<div v-if="messageList.type == 1">
								<div class="wx-chat-time">{{messageList.time}}</div>
								<div class="wx-chat-servicer">
									<div class="wx-servicer-avantar-wrap">
										<img v-if="TYPE == 0" src="../assets/doctor.png" class="wx-servicer-avantar" style="width: 40px;height: 40px;">
										<img v-else src="../assets/charUser.png" class="wx-servicer-avantar" style="width: 30px;height: 30px;">
									</div>
									<div class="wx-chat-msgleft">
										<div v-if="messageList.stype == 1" class="bgnr-txt" v-html="replaceFace(messageList.content)" @click="imgChange($event)"></div>
									</div>
								</div>
							</div>

							<!-- 用户发送的消息模板-->
							<div v-else>
								<div class="wx-chat-time">{{messageList.time}}</div>
								<div class="wx-chat-customer">
									<div style="text-align: center;" v-if="messageList.failure == false">
										<van-icon name="warning" color="red" size="22px" />
										<div style="font-size: 12px;">发送失败</div>
									</div>
									<div class="wx-chat-msgright">
										<div v-if="messageList.stype == 1" class="bgnr-txt" v-html="replaceFace(messageList.content)" @click="imgChange($event)"></div>
									</div>
									<div class="wx-customer-avantar-wrap">
										<img v-if="headInfo.headImg || headInfo.headImg == undefined" src="../assets/charUser.png" class="wx-servicer-avantar" style="width: 30px;height: 30px;">
										<img v-else :src="headInfo.headImg" class="wx-servicer-avantar">
									</div>
								</div>
							</div>
						</li>
					</ul>
				</van-pull-refresh>
			</div>
		</div>

		<div class="xw-footer-wrap" @touchstart="toShowMaskInfo=false">
			<div class="xw-footer-content">
				<div class="xw-vmodel-wrap">
					<input class="xw-content-textarea" placeholder="请输入您的问题" v-model.trim="content" @focus="onFocusText" oninput="if(value.length > 100)value=value.slice(0,100)"></input>
				</div>
				<div class="wx-chat-tool">
					<div class="wx-chat-tool-item">
						<transition name="fade">
							<a href="javascript:void(0)" class="wx-send-btn-text" v-if="content.trim().length" @click="sendMsg">发送</a>
						</transition>
					</div>

					<div class="wx-chat-tool-item">
						<img class="wx-icon" src="../assets/icon-add.png" @click="showMoreOpratin=!showMoreOpratin" />
						<van-action-sheet v-model="showMoreOpratin" title="操作">
							<div class="handle-list">
								<label>
				                  <input type="file" name="image"  accept="image/*"  multiple style="display:none;" @change="changeImage($event)" ref="avatarInput">
				                  <img src="../assets/imgUpdate.png"/>
			                  	</label>
							</div>
							<!--<div class="handle-list">
								<label>
				                <form id="myForm" enctype="multipart/form-data" name="fileinfo" action="" target="uploadFrame">
				                    <div class="img-file">
				                      <label for="imgFile" class="addbutton button-green" style="display:none;" >选择视频</label>
								<input @change="changeVideo" id="imgFile" class="upload_input" type="file" style="display:none;" accept="video/*" />
								<img src="../assets/video.png" />
							</div>
							</form>
							</label>
					</div>-->
					</van-action-sheet>
				</div>
			</div>
		</div>
		<div v-show="previewImgShow" class="backColor" @click="previewImgHide"></div>
		<img v-show="previewImgShow" class="previewImg" :src="previewImg" @click="previewImgHide"/>
	</div>

	<!-- 提示音 -->
	<audio style="display:none" preload="metadata" controls="controls" autoplay="autoplay" ref="hintAudio">
		<!--<source :src="myaudio" type="audio/mpeg" />-->
	</audio>

	</div>
</template>

<script>
	export default {
		name: 'chatRoom',
		data() {
			return {
				isLoading: false, //下拉刷新
				toShowMaskInfo: false, //点击头部是否显示相信信息
				showMoreOpratin: false, //是否显示更多操作,图片 视频等
				testContents: ["今天天气不错", '这个问题还没遇到过', '你说什么，我听不明白', '今天周五了', '请稍后--', '当前客服忙', '您还有什么咨询的吗', '正在查询', 'gone with the wind'],
				content: '',
				//聊天记录
				records: [{
					type: 1, //1、接收方 2、发送方
					stype: 1, //1、文字 2、图片 3、视频
					time: new Date().toLocaleTimeString(),
					failure: true, //信息是否发送成功
					content: '您好！欢迎来到掌上医院，请问有什么能帮到您？如有疑问请在线咨询！感谢您的支持! '
				}],
				stompClient: '',
				timer: '',
				user: JSON.parse(localStorage.getItem('userInfo')),
				doctorInfor: {},
				fromUser: {}, //fromId fromName fromImg formType
				toUser: {}, //toId toName toImg toType
				TYPE: '', //发送0-患者（游客） 或者1-医生
				headInfo: {}, //头部显示的姓名信息等
				page: 1, //聊天记录页数
				previewImg: '',//预览图片路径
				previewImgShow: false,
				initStute: true,//连接是否断开
			}
		},

		methods: {
			//头部显示隐藏
			showInfo() {
				this.toShowMaskInfo = true;
			},
			//下拉记录
			onRefresh() {
				let that = this;
				this.$store.commit('Load', true)
				setTimeout(() => {
					that.page += 1;
					that.$store.commit('Load', false)
					that.isLoading = false;

					that.$Axios.Get('/chats/getUserChatsDetailedPage?limit=10&page=' + that.page + '&toUserId=' + that.toUser.toId + '&toUserType=' + that.toUser.toType + '&fromUserId=' + that.fromUser.fromId + '&fromUserType=' + this.fromUser.fromType, null).then(res => {
						console.log(res)
						if(res.code == 0) {
							let records = res.page.list;
							if(records != '') {
								that.$toast("加载成功")
								for(let i = 0, len = records.length; i < len; i++) {
									if(records[i].fromUserType == that.TYPE) { //如果发信息记录是当前查看人
										that.records.unshift({
											time: records[i].createDate,
											content: records[i].content,
											type: 2,
											stype: 1,
											failure: true,
										});
									} else {
										that.records.unshift({
											time: records[i].createDate,
											content: records[i].content,
											type: 1,
											stype: 1,
											failure: true,
										});
									}
								}
							} else {
								that.$toast("无记录")
							}
						}
					}).catch(err => {
						console.log(err)
						that.connectionToast()
					})
				}, 1000);
			},
			//提示音
			hint(staus) {
				if(staus != undefined) {
					this.bellStatus = !this.bellStatus;
				}
				this.bellStatus ? this.$refs.hintAudio.play() : this.$refs.hintAudio.pause();
			},
			previewImgHide(){
				this.previewImgShow = false;
			},
			//预览图片
			imgChange(e){
				console.log(e.path)
				if(e.path[0].currentSrc != '' && e.path[0].currentSrc != undefined){
					this.previewImg = e.path[0].currentSrc;
					this.previewImgShow = true;
				}
			},
			//图片发送
			changeImage(e) {
				let that = this;
				let files = e.target.files[0];
				if(!e || !window.FileReader) return; // 看支持不支持FileReader
				let formData = new FormData(); //通过formdata上传
				formData.append('file', files);

				this.$Axios.updaImg(this.$Axios.Urlimg + '/fileUpload', formData, res => {
					console.log(res)
					
					let urlimg = this.$Axios.Urlimg + res.path;
					if(res.code == 0) {
						let imgSrc;
						if(urlimg){
							imgSrc = '<img src="' + urlimg + '"  alt="" style="width:200px; height:200px" />';
						}else{
							imgSrc = '<img src="' + urlimg + '"  alt="" style="width:30px; height:30px" />';
						}
						
						that.content = imgSrc;
						that.sendMsg();
					} else {
						console.log(res.msg);
						let imgSrc = '<img src="' + urlimg + '"  alt="" style="width: 30px; height: 30px" />';
						that.content = imgSrc;
						that.sendMsg();
					}
				}), error => {
					console.log(error)
				};
				event.target.type = 'text'; //清楚上传的图片
				event.target.value = '';
				event.target.type = 'file';
				this.showMoreOpratin = false;
				this.scrollToBottom();
			},
			//发送视频
			changeVideo() {
				let that = this;
				var file = document.getElementById("imgFile").files[0];
				that.file = file;
				var ids = this.ids;
				var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加 到FormData里面，这样就可以直接把formData作为参数传递了
				if(file) {
					formData.append("file", file); //接口需要传递的参数
				}
				let potss = formData;
				//              let urls = "http:url地址";
				//              axios.post(urls, potss)
				//                  .then(function(res) {
				//                      that.prames.videoUrl = res.data.info;
				//                      that.videoshow = false;
				//                  })
				//                  .catch(function(err) {
				//                      console.log(err);
				//                  });
				this.$Axios.Post('/', formData).then(data => {
					console.log(data)
				}).catch(err => {
					console.log(err)
				})
			},
			//发送消息
			sendMsg() {
				let content = this.content.trim();
				console.log(content)
				this.records.push({
					time: new Date().toLocaleTimeString(),
					content: content,
					type: 2,
					stype: 1,
					failure: this.initStute,
				});
				
				let that = this;
				that.stompClient.send("/app/points", {}, JSON.stringify({
					content: content, //消息内容
					fromUserId: that.fromUser.fromId, //发送消息用户编号
					fromUserType: that.fromUser.fromType, //用户类型，0、用户 1、医生
					fromUserName: that.fromUser.fromName, //发送消息的用户名称
					fromUserHeadImgUrl: that.fromUser.fromImg, //发消息的用户头像
					fromUserIdZ: that.fromUser.fromZyId,//后面添加 有住院id
					
					toUserId: that.toUser.toId, //接收消息的用户编号
					toUserType: that.toUser.toType, //接收信息的用户类型
					toUserName: that.toUser.toName, //接收消息的用户名称
					toUserHeadImgUrl: that.toUser.toImg, //接收消息的用户头像
					toUserIdZ: that.toUser.toZid,//后面添加 有住院id
				}), ) //用户加入接口
				this.content = '';
				this.scrollToBottom();
				if(!that.initStute){
					that.connectionToast()
				}
				
			},
			//文本处理
			replaceFace(con) {
				if(!con) {
					return;
				}
				if(con.toString().indexOf('/:') > -1) { //表情
					var exps = this.EXPS;
					for(var i = 0; i < exps.length; i++) {
						con = con.replace(exps[i].reg, '<img src="' + exps[i].file + '"  alt="" />');
					}
				}else{
					if(con.split('"')[4] == ' />'){//是图片
						let imgsplit = con.split('"')[1];
						con = '<img src="' + imgsplit + '" style="width: 200px; height: 200px;" alt="" />'
					}
					
				}
				return con;
			},

			//建立连接
			initWebSocket() {
	            this.init()
	            // let that= this
	            // 断开重连机制,尝试发送消息,捕获异常发生时重连
	            // this.timer = setInterval(() => {
	            //     try {
	            //         that.stompClient.send("/app/points",{},JSON.stringify({name: 'admin'}),)   //用户加入接口 
	            //     } catch (err) {
	            //         console.log("断线了: " + err)
	            //         that.init();
	            //     }
	            // }, 5000);
	        },
			//连接方法
			init() {
				// 建立连接对象
				let socket = new this.$SockJS(this.$Axios.Url + '/endpointSang')
				// 获取STOMP子协议的客户端对象
				this.stompClient = this.$Stomp.over(socket);
				// 定义客户端的认证信息,按需求配置
				let headers = {
					content: 'admin'
				}
				let that = this;
				// 向服务器发起websocket连接
				this.stompClient.connect(headers, () => {
					// 这里的路径需要和后台 发送人保持一致
					this.stompClient.subscribe('/user/' + that.TYPE + '_' + that.fromUser.fromId + '/queue/points', function(data) { //订阅消息
						console.log("******收到消息了********")
						console.log(data)
						let message = JSON.parse(data.body);
						let content = message.content.split('/');
						if(Number(that.TYPE == 1)){//医生接收到消息
							if(that.toUser.toZid == message.fromUserIdZ || that.toUser.toId == message.fromUserId){//防止多人对一个医生聊天
								if(content[0] == 'data:image') {
									that.records.push({
										time: new Date().toLocaleTimeString(),
										content: '<img src="' + message.content + '"  alt="" style="width:200px;height:200px"/>',
										type: 1,
										stype: 1,
										failure: true,
									});
								} else {
									that.records.push({
										time: new Date().toLocaleTimeString(),
										content: message.content,
										type: 1,
										stype: 1,
										failure: true,
									});
								}
								that.initStute = true;
								that.scrollToBottom();
							}
						}else{//患者接收到消息
							console.log(that.toUser)
							if(that.toUser.toId == message.fromUserId){//同一个医生
								if(content[0] == 'data:image') {
									that.records.push({
										time: new Date().toLocaleTimeString(),
										content: '<img src="' + message.content + '"  alt="" style="width:200px;height:200px"/>',
										type: 1,
										stype: 1,
										failure: true,
									});
								} else {
									that.records.push({
										time: new Date().toLocaleTimeString(),
										content: message.content,
										type: 1,
										stype: 1,
										failure: true,
									});
								}
								that.initStute = true;
								that.scrollToBottom();
							}
							
						}
					}, headers);

				}, (err) => {
					// 连接发生错误时的处理函数
					// that.records[that.records.length - 1].failure = false;
					that.initStute = false;
					console.log('失败')
					console.log(err)
					that.connectionToast()
				});
			},
			//连接失败提示框
			connectionToast(){
				let that = this;
				this.$dialog.confirm({
					title: '连接失败',
					message: '是否重新连接？'
				}).then(() => {
					setTimeout(()=>{
						that.initWebSocket()
					}, 3000)
				}).catch(() => {});
			},
			// 断开连接
			disconnect() {
				if(this.stompClient) {
					console.log("断开")
					this.stompClient.disconnect();
				}
			},
			
			//滚动到底
			scrollToBottom() {
				setTimeout(() => {
					//滚动条长度
					var currentDistance = this.$refs.xwBody.scrollHeight - this.$refs.xwBody.clientHeight;
					//当前滚动条距离顶部的距离
					var currentScroll_y = this.$refs.xwBody.scrollTop;
					if(currentDistance > 0 && currentDistance > currentScroll_y) {
						currentScroll_y = Math.ceil((currentDistance - currentScroll_y) / 10) + currentScroll_y;
						currentScroll_y = currentScroll_y > currentDistance ? currentDistance : currentScroll_y;
						//微信和qq浏览器不支持 scrollTo？
						//this.$refs.xwBody.scrollTo(0,currentScroll_y);
						this.$refs.xwBody.scrollTop = currentScroll_y;
						this.scrollToBottom();
					}
				}, 13);
			},
			onFocusText() {
//				this.scrollToBottom();
			},
			//聊天记录
			GetUserChatsDetailedPage() {
				console.log(this.fromUser)
				console.log(this.toUser)
				let that = this;
				this.$Axios.Get('/chats/getUserChatsDetailedPage?limit=10&page=1&toUserId=' + this.toUser.toId + '&toUserIdZ=' + this.toUser.toZid + '&toUserType=' + this.toUser.toType + '&fromUserId=' + this.fromUser.fromId + '&fromUserType=' + this.fromUser.fromType + '&fromUserIdZ=' + this.fromUser.fromZyId, null).then(res => {
					console.log(res)
					if(res.code == 0) {
						let records = res.msg.list;
						for(let i = 0, len = records.length; i < len; i++) {
							if(records[i].fromUserType == that.TYPE) { //如果发信息记录是当前查看人
								that.records.push({
									time: records[i].createDate,
									content: records[i].content,
									type: 2,
									stype: 1,
									failure: true,
								});
							} else {
								that.records.push({
									time: records[i].createDate,
									content: records[i].content,
									type: 1,
									stype: 1,
									failure: true,
								});
							}
						}
						this.scrollToBottom();
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取微信挂号人员信息
			GetSysPerson() {
				let that = this;
				this.$Axios.Get('/person/sysPerson?wechatId=' + this.user.openid, null).then(data => {
					console.log(data)
					if(data.code == 0) {
						let dataList = data.msg;
						for(let i = 0; i < dataList.length; i++) {
							if(dataList[i].choice == '0') { //使用本人聊天
								
								that.fromUser.fromZyId = dataList[i].bahm;
								
								that.fromUser.fromId = dataList[i].brid;
								that.fromUser.fromName = dataList[i].name;
								that.fromUser.fromImg = dataList[i].portraitUrl;
								that.fromUser.fromType = 0;
							}
						}
					} else {
						this.VisitorRegister();
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//临时游客
			VisitorRegister() {
				let that = this;
				this.$Axios.Post('/visitorRegister?openid=' + this.user.openid + '&nickname=' + this.user.nickname + '&headimgurl=' + this.user.headimgurl, null).then(res => {
					console.log(res)
					if(res.data.code == 0) {
						this.fromUser.fromId = this.user.openid;
						this.fromUser.fromName = this.user.nickname;
						this.fromUser.fromImg = this.user.headimgurl;
						this.fromUser.fromType = 0;
						this.fromUser.fromZyId = '';
			
						this.headInfo.name = this.user.nickname;
						this.headInfo.text = '游客';
						this.headInfo.headImg = this.user.headimgurl;
						
						that.TYPE = 0;
					}
				}).catch(err => {
					console.log(err)
				})
			},
		},
		beforeDestroy: function() {
			// 页面离开时断开连接,清除定时器
			this.disconnect()
			clearInterval(this.timer)
		},
		mounted() {
			let that = this;
			this.GetSysPerson();
			setTimeout(() => {
				if(JSON.stringify(that.$route.query.questions) != undefined) { //医生查看提问
					console.log("我是医生")
					let info = JSON.parse(that.$route.query.questions);
					console.log(info)
					that.fromUser.fromId = info.toUserId; //发送用户
					that.fromUser.fromType = 1; //发送用户
					that.fromUser.fromName = info.toUserName; //发送用户姓名
					that.fromUser.fromZyId = info.toUserIdZ;
					
					that.toUser.toId = info.fromUserId; //接收用户
					that.toUser.toType = 0; //接收用户
					that.toUser.toName = info.fromUserName; //接收用户姓名
					that.toUser.toZid = info.fromUserIdZ;
					
					that.TYPE = 1;
	
					that.headInfo.name = info.fromUserName;
					that.headInfo.text = '咨询人';
					that.headInfo.headImg = info.fromUserHeadImgUrl;
				} else {
					that.TYPE = 0;
				}
				
				if(JSON.stringify(that.$route.query.doctor) != undefined) { //点击医生进来聊天
					console.log("我是患者")
					let infoDoc = JSON.parse(that.$route.query.doctor);
					console.log(infoDoc)
					that.headInfo.name = infoDoc.YGXM == '' ? infoDoc.toUserName : infoDoc.YGXM;
					that.headInfo.text = infoDoc.YGJB == '' ? '咨询人' : infoDoc.YGXM;
					that.headInfo.headImg = infoDoc.HEAD_PORTRAIT_URL == '' ? infoDoc.toUserHeadImgUrl : infoDoc.HEAD_PORTRAIT_URL;
					
					if(infoDoc.ygdm != undefined){
						that.toUser.toId = infoDoc.ygdm == undefined ? infoDoc.fromUserId : infoDoc.ygdm;//接收用户id
						that.toUser.toType = 1;
						that.toUser.toName = infoDoc.ygxm == undefined ? infoDoc.fromUserName : infoDoc.ygxm; //接收用户姓名
						that.toUser.toImg = infoDoc.headPortraitUrl == undefined ? infoDoc.fromUserHeadImgUrl : infoDoc.headPortraitUrl;
						that.toUser.toUserIdZ = '';
						that.TYPE = 0;
					}else{
						that.toUser.toId = infoDoc.YGDM == undefined ? infoDoc.fromUserId : infoDoc.YGDM;//接收用户id
						that.toUser.toType = 1;
						that.toUser.toName = infoDoc.YGXM == undefined ? infoDoc.fromUserName : infoDoc.YGXM; //接收用户姓名
						that.toUser.toImg = infoDoc.HEAD_PORTRAIT_URL == undefined ? infoDoc.fromUserHeadImgUrl : infoDoc.HEAD_PORTRAIT_URL;
						that.toUser.toUserIdZ = '';
						that.TYPE = 0;
					}
					
				}
				
				that.initWebSocket();
				that.GetUserChatsDetailedPage();
			}, 1000)
			
		},
		created() {
		},
	}
</script>

<style scoped>
	.con {
		position: relative;
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		background-color: #ccc;
	}
	
	.wx-header {
		padding: 10px;
		background: linear-gradient(to left, #27BEC4, #fff);
		color: #000;
		font-size: 15px;
	}
	
	.wx-header-content-disp {
		display: flex;
		align-items: center;
	}
	
	.wx-header-avatar,
	.xw-logo img {
		width: 50px;
		height: 50px;
		overflow: hidden;
		border-radius: 50%;
	}
	
	.xw-header-title {
		margin-left: 10px;
	}
	
	
	.wx-customer-avantar-wrap img {
		width: 30px;
		height: 30px;
	}
	
	.wx-chat-time {
		margin: 10px 0;
		font-size: 12px;
		text-align: center;
	}
	
	.wx-chat-servicer,
	.wx-chat-customer {
		display: flex;
	}
	
	.wx-chat-msgleft {
		position: relative;
		padding: 2px 8px;
		margin-left: 10px;
		margin-right: 20%;
		background-color: #27BEC4;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		border-top-right-radius: 2px;
		border-bottom-right-radius: 2px;
	}
	
	.wx-chat-msgleft::before {
		content: '';
		position: absolute;
		width: 0;
		height: 0;
		left: -20px;
		top: 5px;
		border: 10px solid;
		border-color: transparent #27BEC4 transparent transparent;
	}
	
	.wx-chat-customer {
		justify-content: flex-end;
		margin-left: 20%;
	}
	
	.wx-chat-msgright {
		display: flex;
		position: relative;
		padding: 2px 8px;
		margin-right: 15px;
		margin-left: 5%;
		background-color: #fff;
		color: #000;
		font-size: 14px;
		line-height: 30px;
		border-top-left-radius: 2px;
		border-bottom-left-radius: 2px;
	}
	
	.wx-chat-msgright::after {
		content: '';
		position: absolute;
		width: 0;
		height: 0;
		right: -20px;
		top: 5px;
		border: 10px solid;
		border-color: transparent transparent transparent #fff;
	}
	
	.wx-content {
		padding: 5px 10px;
		flex: 1;
		position: relative;
		overflow: auto;
		transition: height .8s;
	}
	
	.xw-footer-wrap {
		padding: 5px;
		background-color: #fff;
	}
	
	.xw-vmodel-wrap {
		width: 70%;
	}
	
	.xw-content-textarea {
		padding: 10px;
		width: 85%;
		border-radius: 10px;
		border: 1px solid #ccc;
		box-shadow: 0;
	}
	
	.xw-footer-content {
		display: flex;
		align-items: center;
	}
	
	.wx-send-btn-text {
		padding: 10px 15px;
		background-color: #27BEC4;
		color: #fff;
		border-radius: 10px;
	}
	
	.bgnr-txt img,
	.bgnr-img {
		width: 200px !important;
		height: 200px !important;
	}
	
	.wx-chat-tool {
		width: 28%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.wx-icon {
		width: 30px;
		height: 30px;
	}
	
	.van-action-sheet__content {
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	
	.handle-list img {
		width: 50px;
		height: 50px;
	}
	.backColor{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: #000000;
		z-index: 5;
	}
	.previewImg{
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		width: 80%;
		max-height: 100%;
		z-index: 10;
	}
	/**********************/
	
	.slide-fade-enter-active {
		transition: all .3s ease;
	}
	
	.slide-fade-leave-active {
		transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	
	.slide-fade-enter,
	.slide-fade-leave-to {
		transform: translateX(20px);
		opacity: 0;
	}
	
	.animated {
		-webkit-animation-duration: 1s;
		animation-duration: 1s;
		-webkit-animation-fill-mode: both;
		animation-fill-mode: both;
	}
	
	.animated.bounceIn,
	.animated.bounceOut {
		-webkit-animation-duration: .75s;
		animation-duration: .75s;
	}
	
	@-webkit-keyframes bounceInDown {
		from,
		60%,
		75%,
		90%,
		to {
			-webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
			animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
		}
		0% {
			opacity: 0;
			-webkit-transform: translate3d(0, -3000px, 0);
			transform: translate3d(0, -3000px, 0);
		}
		60% {
			opacity: 1;
			-webkit-transform: translate3d(0, 25px, 0);
			transform: translate3d(0, 25px, 0);
		}
		75% {
			-webkit-transform: translate3d(0, -10px, 0);
			transform: translate3d(0, -10px, 0);
		}
		90% {
			-webkit-transform: translate3d(0, 5px, 0);
			transform: translate3d(0, 5px, 0);
		}
		to {
			-webkit-transform: none;
			transform: none;
		}
	}
	
	.bounceInDown {
		-webkit-animation-name: bounceInDown;
		animation-name: bounceInDown;
	}
	
	@keyframes bounceInLeft {
		from,
		60%,
		75%,
		90%,
		to {
			-webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
			animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
		}
		0% {
			opacity: 0;
			-webkit-transform: translate3d(-3000px, 0, 0);
			transform: translate3d(-3000px, 0, 0);
		}
		60% {
			opacity: 1;
			-webkit-transform: translate3d(25px, 0, 0);
			transform: translate3d(25px, 0, 0);
		}
		75% {
			-webkit-transform: translate3d(-10px, 0, 0);
			transform: translate3d(-10px, 0, 0);
		}
		90% {
			-webkit-transform: translate3d(5px, 0, 0);
			transform: translate3d(5px, 0, 0);
		}
		to {
			-webkit-transform: none;
			transform: none;
		}
	}
	
	.bounceInLeft {
		-webkit-animation-name: bounceInLeft;
		animation-name: bounceInLeft;
	}
	
	@-webkit-keyframes bounceInRight {
		from,
		60%,
		75%,
		90%,
		to {
			-webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
			animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
		}
		from {
			opacity: 0;
			-webkit-transform: translate3d(3000px, 0, 0);
			transform: translate3d(3000px, 0, 0);
		}
		60% {
			opacity: 1;
			-webkit-transform: translate3d(-25px, 0, 0);
			transform: translate3d(-25px, 0, 0);
		}
		75% {
			-webkit-transform: translate3d(10px, 0, 0);
			transform: translate3d(10px, 0, 0);
		}
		90% {
			-webkit-transform: translate3d(-5px, 0, 0);
			transform: translate3d(-5px, 0, 0);
		}
		to {
			-webkit-transform: none;
			transform: none;
		}
	}
	
	.bounceInRight {
		-webkit-animation-name: bounceInRight;
		animation-name: bounceInRight;
	}
	
	@keyframes bounceInUp {
		from,
		60%,
		75%,
		90%,
		to {
			-webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
			animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
		}
		from {
			opacity: 0;
			-webkit-transform: translate3d(0, 3000px, 0);
			transform: translate3d(0, 3000px, 0);
		}
		60% {
			opacity: 1;
			-webkit-transform: translate3d(0, -20px, 0);
			transform: translate3d(0, -20px, 0);
		}
		75% {
			-webkit-transform: translate3d(0, 10px, 0);
			transform: translate3d(0, 10px, 0);
		}
		90% {
			-webkit-transform: translate3d(0, -5px, 0);
			transform: translate3d(0, -5px, 0);
		}
		to {
			-webkit-transform: translate3d(0, 0, 0);
			transform: translate3d(0, 0, 0);
		}
	}
	
	.bounceInUp {
		-webkit-animation-name: bounceInUp;
		animation-name: bounceInUp;
	}
</style>
